import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import { Button, Tooltip, Box } from '@mui/material';
import { postTicketBoomerang } from "../../../api/tickets";
import { updateSingleTicket } from '../../../redux/slices/tickets';

TicketsLeftLabel.propTypes = {
  ticket: PropTypes.object,
}

export default function TicketsLeftLabel({ticket}) {

  const dispatch = useDispatch();

  const removeReminder = async (ticket) => {
    const response = await postTicketBoomerang({ date: null, ticketId: ticket.id });
    if (response.status === 200 || response.status === 204) {
      dispatch(updateSingleTicket({...ticket, boomerangOn: null, wasBoomeranged: false, aboveLine: false }));
    }
  }

  const { wasBoomeranged, messageCount, subticketsUnread } = ticket;
  const mainTicketRead = messageCount === 0;
  const areAllSubticketsRead = subticketsUnread?.length === 0; 
  const read = mainTicketRead && areAllSubticketsRead;
  const totalItemsUnread = mainTicketRead ? 0 + (subticketsUnread?.length || 0) : 1 + (subticketsUnread?.length || 0);
  const subticketsUnreadInfo = `${subticketsUnread?.length} subticket${subticketsUnread?.length !== 1 ? 's' : ''}`;

  return (
    <Tooltip
      title={wasBoomeranged ? 'Reminder': (
      <>
        <Box sx={{fontWeight: 'bold'}} component="span">
          {!read ? `${totalItemsUnread} unread ${totalItemsUnread !== 1 ? 'items' : 'item'}` : ''}
        </Box>
        {!mainTicketRead && !areAllSubticketsRead ? 
          <Box> {`Main ticket, ${subticketsUnreadInfo}`}</Box> :
          <span> {!mainTicketRead ? '(Main Ticket)' : !areAllSubticketsRead ? `(${subticketsUnreadInfo})` : ''}</span>}
        <Box>{`Click to mark all as ${read ? 'unread' : 'read'}`}</Box>
      </>)
   }>
      <Button
        size="small"
        variant="contained"
        onClick={(event) => {
          if (read) event.unread = true;
          else if (wasBoomeranged) {
            event.stopPropagation();
            event.preventDefault();
            removeReminder(ticket);
          }
          else event.read = true;
        }}
        sx={{
          mb: '2px',
          pl: 0,
          maxWidth: '10px',
          minWidth: '10px',
          width: '10px',
          height: '100%',
          borderRadius: 0,
          backgroundColor: wasBoomeranged ? "secondary.main" : read ? '#fff' : '#208ee0',
          '&:hover': {
            cursor: 'pointer',
            backgroundColor: wasBoomeranged ? "secondary.main" : read ? '#fff' : '#208ee0',
            opacity: 0.8,
          },
        }}
      />
    </Tooltip>
  );
}